import React from 'react';
import { Box, Paper } from '@mui/material';
import LoginForm from '../components/Auth/LoginForm';

const LoginPage = () => (
  <Box
    sx={{
      minHeight: '100vh',
      background: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 2,
    }}
  >
    <Paper
      elevation={24}
      sx={{
        maxWidth: 480,
        width: '100%',
        overflow: 'hidden',
        borderRadius: 3,
      }}
    >
      <Box sx={{ p: { xs: 3, sm: 4, md: 5 } }}>
        <LoginForm />
      </Box>
    </Paper>
  </Box>
);

export default LoginPage;
